/**
 * Owner 2026-10-24 16:15 (pkt 5): „jak brakuje danej pozycji i informujesz o tym w dopożyczeniach, to pisz ile brakuje w
 * danym wydarzeniu oraz w nawiasie ile brakuje na inne wydarzenia łącznie i na które; pozwól na nie kliknąć, żeby
 * przejść do ich sprzętówki”. `GET /api/packlists/:eventId/shortages/elsewhere` (rule 7a: a hidden event has no id).
 */
export type ElsewhereItem = { itemId: string; missing: number; otherMissing: number; events: Array<{ eventId: string | null; name: string; missing: number }> };

/** The packlist of an event (its card, tab „Sprzętówka”). */
export const packlistUrl = (eventId: string): string => `/wydarzenia?wydarzenie=${encodeURIComponent(eventId)}&zakladka=sprzetowka`;

/** „(na inne wydarzenia łącznie N: A, B)” — the lead and the events (a link to each one's packlist when seen); null: none. */
export function elsewhereNote(item: ElsewhereItem | undefined): { lead: string; events: Array<{ key: string; name: string; href: string | null; title: string }> } | null {
  if (!item || item.otherMissing <= 0 || item.events.length === 0) return null;
  let hidden = 0;
  return {
    lead: `na inne wydarzenia łącznie ${item.otherMissing}: `,
    events: item.events.map((e) =>
      e.eventId ? { key: e.eventId, name: e.name, href: packlistUrl(e.eventId), title: `Brakuje ${e.missing} — otwórz sprzętówkę` } : { key: `h${++hidden}`, name: e.name, href: null, title: `Brakuje ${e.missing}` },
    ),
  };
}
